<template>
  <div>
    <div :class="'alert alert-' + alertType" v-if="message">
      <h5 style="color: white; text-align: center; font-family: sans-serif">
        {{ message }}
      </h5>
    </div>
  </div>
</template>
<script>
export default {
  name: "AlertComponent",
  props: ["message", "alertType"],
  components: {},
  data() {
    return {};
  },
  mounted() {},
  created() {},
  methods: {},
};
</script>